// Namespace "public" — fragment "packs" (C2.03 public session-pack purchase).
export default {
  fr: {
    "packs.title": "Forfaits de séances",
    "packs.subtitle": "Choisissez un forfait, réglez-le en une fois, et utilisez-le lors de vos prochaines réservations.",
    "packs.empty": "Aucun forfait disponible pour l'instant.",
    "packs.sessions": "{n} séances",
    "packs.namePh": "Votre nom",
    "packs.emailPh": "Votre e-mail",
    "packs.promoPh": "Code promo (facultatif)",
    "packs.buy": "Acheter · {name}",
    "packs.toast.error": "Le paiement n'a pas pu démarrer. Réessayez.",
    "packs.toast.loadError": "Impossible de charger les forfaits.",
    "checkout.pack.title": "Forfait activé 🌿",
    "checkout.pack.desc": "{practitionerName} vous contactera pour planifier vos séances.",
  },
  en: {
    "packs.title": "Session packs",
    "packs.subtitle": "Choose a pack, pay for it once, and use it on your next bookings.",
    "packs.empty": "No packs available right now.",
    "packs.sessions": "{n} sessions",
    "packs.namePh": "Your name",
    "packs.emailPh": "Your email",
    "packs.promoPh": "Promo code (optional)",
    "packs.buy": "Buy · {name}",
    "packs.toast.error": "The payment could not start. Try again.",
    "packs.toast.loadError": "Packs could not be read.",
    "checkout.pack.title": "Pack activated 🌿",
    "checkout.pack.desc": "{practitionerName} will reach out to schedule your sessions.",
  },
  es: {
    "packs.title": "Bonos de sesiones",
    "packs.subtitle": "Elige un bono, págalo una vez y úsalo en tus próximas reservas.",
    "packs.empty": "No hay bonos disponibles por ahora.",
    "packs.sessions": "{n} sesiones",
    "packs.namePh": "Tu nombre",
    "packs.emailPh": "Tu correo",
    "packs.promoPh": "Código promocional (opcional)",
    "packs.buy": "Comprar · {name}",
    "packs.toast.error": "El pago no pudo iniciarse. Inténtalo de nuevo.",
    "packs.toast.loadError": "No se pudieron leer los bonos.",
    "checkout.pack.title": "Bono activado 🌿",
    "checkout.pack.desc": "{practitionerName} se pondrá en contacto para programar tus sesiones.",
  },
};
